import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, MatIconModule],
  templateUrl: './app-footer.html',
  styleUrl: './app-footer.css',
})
export class AppFooter {}
